import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Global helper `go(path)` used across components in the project.
// Provides a safe fallback navigation when a router helper is not available.
if (typeof window !== 'undefined' && typeof window.go !== 'function') {
  window.go = function go(path) {
    try {
      if (!path) return;
      // If path looks like an absolute URL, navigate directly
      if (/^https?:\/\//i.test(path)) {
        window.location.href = path;
        return;
      }
      // Normalize and navigate within the site
      const normalized = path.toString().trim().replace(/^\/*/, '');
      window.location.href = '/' + normalized;
    } catch (e) {
      // Fall back to root on error
      window.location.href = '/';
    }
  };
}
